import { Button } from "react-bootstrap";

export const ThemeButton = ({ text, className, onClick }) => {
  return (
    <Button className={`theme-btn ${className}`} onClick={onClick}>
      {text}
    </Button>
  );
};
